import { Checkbox, FormControlLabel, FormGroup, TableCell, TableRow } from '@mui/material'
import { snakeCase } from 'lodash'

import { SelectionRowProps } from 'common/interfaces'
import { selectionRowStyle } from 'common/styles'

export default function CheckboxGroupRows({
  item,
  variants,
  value,
  handleChange,
}: SelectionRowProps): JSX.Element {
  const { groupWrap, controlLabel } = selectionRowStyle
  const checkboxGroupName = snakeCase(item)

  return (
    <TableRow>
      <TableCell>{item}</TableCell>
      <TableCell>
        <FormGroup row sx={groupWrap}>
          {variants.map((variant) => (
            <FormControlLabel
              control={
                <Checkbox
                  name={checkboxGroupName}
                  value={variant}
                  checked={value?.[checkboxGroupName]?.includes(variant) ?? false}
                  onChange={(event) => handleChange(event, variant)}
                />
              }
              label=""
              key={item + variant}
              sx={controlLabel}
            />
          ))}
        </FormGroup>
      </TableCell>
    </TableRow>
  )
}
